import { Component, OnInit, Input, ViewChild, Output, EventEmitter } from '@angular/core';
import { SearchComponent } from '../../components/common/search/search.component';
import { CompetitorDto, CurrentCompetitorsSearchModel, AwardDto, CompetitorAwardSearchStorage, CompetitorAwardsSearchModel } from '../../models/competitors/competitor.models';
import { Configuration } from '../../configuration';
import { Helpers } from '../../helpers';
import { IPage } from '../../models/common/paging';
import { BaseCompetitorsComponent } from './base.competitors.component';
import { CompetitorCurrentService } from '../../services/competitor.current.service';
import { RouterService } from '../../services/routerService';
import { LoggedInUserService, LoggedInUser } from '../../auth/logged.in.user';

@Component({
    selector: 'view-competitors',
    template: require('./view.competitors.component.html')
})
export class ViewCompetitorsComponent extends SearchComponent<CurrentCompetitorsSearchModel, CompetitorDto>{

    base: BaseCompetitorsComponent;
    viewedCompany: string;
    competitorAwards: IPage<AwardDto>;
    awardsModel: CompetitorAwardsSearchModel;
    private readonly user: LoggedInUser;

    @ViewChild('viewCompetitorModal', { static: false }) private viewCompetitorModal: any;
    @Output() showAwards = new EventEmitter<void>();
    @Output() onRemove = new EventEmitter<any>();

    constructor(private readonly competitorService: CompetitorCurrentService, configuration: Configuration, helpers: Helpers, private router: RouterService, private readonly loggedInUserService: LoggedInUserService) {
        super(new CurrentCompetitorsSearchModel(configuration), competitorService, helpers);
        this.awardsModel = new CompetitorAwardsSearchModel(configuration);
        this.user = loggedInUserService.getCurrentUser();
        $('#viewCompetitorModal').modal();
        $('#viewCompetitorModal').modal('hide');
    }

    refresh() {
        this.search();
    }

    remove(name: string) {
        this.competitorService.remove(name).subscribe((response: any) => {
            this.onRemove.emit();
            this.search();
        });
    }

    getCompanyAwards(competitorname: string) {
        this.viewedCompany = competitorname;
        this.competitorService.getAwardsForCompany(competitorname).subscribe((response: IPage<AwardDto>) => {
            this.competitorAwards = response;
        });
    }

    view(name: string) {
        //this.viewCompetitorModal.showAndPopulate(name);
        var requestToStore = new CompetitorAwardSearchStorage(this.awardsModel);
        requestToStore.awardedCompanyName = name;
        requestToStore.publishedDate = null;
        localStorage.setItem('awardStore', JSON.stringify(requestToStore));
        //this.showAwards.emit();
        //this.router.router.navigate(['/competitors']);
        //this.router.router.navigateByUrl('/competitors?test');
        //window.location.reload();

        this.showAwards.emit();
    }

    teamMember(): boolean {
        return (this.user.role != 'Supplier');
    }
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Client/app/views/competitors/view.competitors.component.ts